import { render } from "./SlideTabComponent.vue?vue&type=template&id=07dff35f&scoped=true"
import script from "./SlideTabComponent.vue?vue&type=script&lang=js"
export * from "./SlideTabComponent.vue?vue&type=script&lang=js"

import "./SlideTabComponent.vue?vue&type=style&index=0&id=07dff35f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07dff35f"]])

export default __exports__